import * as React from 'react';
import { styled, setup } from 'goober';
setup(React.createElement);
export default styled;